import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'clinic-list',
  data: function () {
    return {
      shopList: [],
      showTabs: true,
      showTablists: true,
      showShops: true,
      showLists: true,
      showButtons: true,
      nextUrl: null,
      clinicId: null,
      clinicName: '',
      checkTelDuplicate: false,
      dealEnds: false,
      utils: utils,
      searchCallbackFlag: false, // 検索結果フラグ
      watchScroll: null,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'clinic_name_furigana': {'state': true,  'order': true},
        'address':              {'state': false, 'order': false},
        'tel':                  {'state': false, 'order': false}
      },
      sortStateInit: {},
      maxShopCount: 8
    }
  },
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.clinicsSearchParams !== null) {
        this.$store.getters.clinicsSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.clinicsSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.autocompleteEventRemove({$: $, elem:'#clinic_name_autocomplete'}) // オートコンプリートイベント削除
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created () {
    var readMore = false

    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    if (this.$router.currentRoute.query.type === 'reports_history') {
      this.showTablists = false
      this.showShops = false
      this.showLists = false
      var ssClinicName = window.sessionStorage.getItem('rh-clinicName')
      if (!!ssClinicName) {
        this.clinicName = ssClinicName
      }
    }
    if (this.$router.currentRoute.query.type === 'select_facility') {
      this.showTabs = false
      this.showButtons = false
      var ssShopID = window.sessionStorage.getItem("sfc-shopID")
      var ssClinicName = window.sessionStorage.getItem('sfc-clinicName')
      var ssDealEnds = window.sessionStorage.getItem("sfc-dealEnds")
      var ssSortKey = window.sessionStorage.getItem("sfc-sortKey")
      var ssSortStateOrder = window.sessionStorage.getItem("sfc-sortStateOrder")
      if (!!ssShopID) {
        if (ssShopID === 'null') {
          this.shopId = null
        } else {
          this.shopId = ssShopID
        }
      }
      if (!!ssClinicName) {
        this.clinicName = ssClinicName
      }
      if (!!ssDealEnds) {
        this.dealEnds = Boolean(ssDealEnds)
      }
      if (!!ssSortKey) {
        var key = ssSortKey
        this.sortKey = key
        if (ssSortStateOrder != null) {
          if (ssSortStateOrder === "true") {
            this.sortStateOrder = true
          } else {
            this.sortStateOrder = false
          }
        } else {
          this.sortStateOrder = !this.sortState[key].order
        }
        for (var k in this.sortState) {
          this.sortState[k].state = false
          if (k !== key) {
            this.sortState[k].order = false
          }
        }
        this.sortState[key].state = true
        this.sortState[key].order = this.sortStateOrder
      }
      // this.$store.dispatch('SHOP_SEARCH')
      this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    }

    this.search(readMore)

    // オートコンプリートイベント
    utils.autocompleteEvent({
      $:                  $,
      elem:               '#clinic_name_autocomplete',
      search:             this.search,
      searchParams:       false,
      searchAutocomplete: this.getClinics,
      setSearchData:      this.setSearchClinic,
      clear:              this.clearClinicsAutocomplete,
    })

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  mounted () {
    if (this.$router.currentRoute.query.type === 'select_facility') {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
  },
  computed: {
    orderedClinics () {
      return this.clinics
    },
    clinics () {
      return this.$store.getters.clinics
    },
    clinicsAutocomplete () {
      return this.$store.getters.clinicsAutocomplete
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    nextPage () {
      return this.$store.getters.clinicsNextPage
    },
    totalCount () {
      return this.$store.getters.clinicsTotalCount
    },
    shops () {
      return this.$store.getters.shops
    },
    currentPage () {
      return this.$store.getters.clinicsCurrentPage
    },
    notify () {
      return this.$store.getters.clinicNotify
    },
    overShopCount () {
      if (this.shopList.length > this.maxShopCount) {
        return true
      }
      return false
    }
  },
  methods: {
    goFacilities: function() {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type}})
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type}})
    },
    goClinics: function() {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type}})
    },
    goDoctors: function() {
      this.$router.push({ path: '/doctors', query: { type: this.$router.currentRoute.query.type}})
    },
    goCareOffices: function() {
      this.$router.push({ path: '/care_offices', query: { type: this.$router.currentRoute.query.type}})
    },
    goCareManagers: function() {
      this.$router.push({ path: '/care_managers', query: { type: this.$router.currentRoute.query.type}})
    },
    goClinicRegister: function () {
      this.$router.push({ path: '/clinics/edit', query: { type: this.$router.currentRoute.query.type}})
    },
    goNext: function (id) {
      if (this.$router.currentRoute.query.type === 'reports_history') {
        this.$router.push({ path: '/reports/history/clinic/' + id, query: { type: this.$router.currentRoute.query.type}})
      } else if (this.$router.currentRoute.query.type === 'select_facility') {
        this.$router.push({ path: '/clinics/' + id, query: { type: this.$router.currentRoute.query.type}})
      }
    },
    goPrev: function() {
      if (this.$router.currentRoute.query.type === 'reports_history') {
        this.$router.push({path: '/', query: {type: this.$router.currentRoute.query.type}})
      } else if (this.$router.currentRoute.query.type === 'select_facility') {
        this.$router.push({path: '/', query: {type: this.$router.currentRoute.query.type}})
      }
    },
    setSearchClinic: function (clinicId, clinicName) {
      this.clinicName = clinicName
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 100)
    },
    // clearClinics: function() {
    //   this.$store.dispatch('CLINICS_CLEAR', 0)
    // },
    clearClinicsAutocomplete: function () {
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 500)
    },
    getClinics: function () {
      this.clinicId = null
      this.search(false, 'autocomplete')
    },
    searchTelDuplicate: function() {
      this.checkTelDuplicate = !this.checkTelDuplicate
      this.search(false)
    },
    search: function(readMore, mode) {
      var url = null
      var clear = true
      var autocomplete = false
      var loadparams = true
      var send_fails = 0
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.clinicsSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.clinicsSearchParams['scrollHeight']
        this.$store.getters.clinicsSearchParams['pageYOffset'] = null
        this.$store.getters.clinicsSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        url = this.$store.getters.clinicsNextPage
        clear = false
        loadparams = 'block'
      } else {
        if (mode !== 'autocomplete') {
          this.searchCallbackFlag = false
        }
      }

      if (mode === 'autocomplete') {
        autocomplete = true
        clear = false
        loadparams = false
      } else if (this.$router.currentRoute.query.type === 'reports_history') {
        send_fails = 1
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {
        'shop_id':             this.shopId,
        'clinic_name':         this.clinicName,
        'send_fails':          send_fails,
        'deal_ends':           this.dealEnds,
        'tel_duplicate_check': this.checkTelDuplicate,
        'order':               this.orderByString(),
        'type':                this.$router.currentRoute.query.type
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      if (this.$router.currentRoute.query.type === 'reports_history') {
        if (!!this.clinicName) {
          window.sessionStorage.setItem('rh-clinicName', this.clinicName)
        } else {
          window.sessionStorage.removeItem('rh-clinicName')
        }
      }
      if (this.$router.currentRoute.query.type === 'select_facility') {
        window.sessionStorage.setItem("sfc-shopID", this.shopId)
        if (!!this.clinicName) {
          window.sessionStorage.setItem('sfc-clinicName', this.clinicName)
        } else {
          window.sessionStorage.removeItem('sfc-clinicName')
        }
        if (this.dealEnds == true) {
          window.sessionStorage.setItem("sfc-dealEnds", this.dealEnds)
        } else {
          window.sessionStorage.removeItem("sfc-dealEnds")
        }
        if (!!this.sortKey) {
          window.sessionStorage.setItem("sfc-sortKey", this.sortKey)
        } else {
          window.sessionStorage.removeItem("sfc-sortKey")
        }
        if (this.sortStateOrder !== "") {
          window.sessionStorage.setItem("sfc-sortStateOrder", this.sortStateOrder)
        } else {
          window.sessionStorage.removeItem("sfc-sortStateOrder")
        }
      }
      this.$store.dispatch('CLINIC_SEARCH', {url: url, clear: clear, data: data, autocomplete: autocomplete, loadparams: loadparams, callback: callback})
    },
    clearSearchParams: function () {
      if (this.$store.getters.canManage && this.shopId === null) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.clinicId = null
      this.clinicName = ''
      this.$store.dispatch('CLINICS_CLEAR', 0)
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          if (key === 'address') {
            result.push('post_no ' + asc_desc)
            result.push('address1 ' + asc_desc)
            result.push('address2 ' + asc_desc)
          } else {
            result.push(key + ' ' + asc_desc)
          }
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('clinic_name_furigana asc')
      }
      return result.join(' , ')
    },
    // 店舗別担当施設表示  
    goSurroundingSearchByShops: function() {
      if (this.overShopCount) {
        return
      }
      this.shopList.sort(function (a, b) {
        return a - b
      })
      var data = {
        'shop_list': this.shopList
      }
      this.$store.dispatch('CLINIC_SHOP_LIST_SAVE', {data: this.shopList})
      this.$store.dispatch('CLINIC_SEARCH_BY_SHOP', {data: data, callback: () => {
        this.$router.push({ name: 'clinicSurrounding', query: { type: this.$router.currentRoute.query.type}})
      }})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/clinic-list.js